
















import Vue from 'vue'
import { createNamespacedHelpers } from 'vuex'
import { IShippingMethod, IStateOrder } from '@/models'
import { STORE_MODULES } from '@/enums'
import { getFormattedPrice } from '@/utils'

const { mapState } = createNamespacedHelpers(STORE_MODULES.ORDER)

export default Vue.extend({
    name: 'BaseShippingMethodListItem',

    props: {
        method: {
            type: Object as () => IShippingMethod,
            required: true,
        },
    },

    computed: {
        ...(mapState(['shipping']) as MapStateToComputed<IStateOrder>),

        isSelected(): boolean {
            return this.shipping?.shippingMethodID === this.method.methodID
        },

        price(): string {
            return getFormattedPrice(this.method.price)
        },
    },
})
